<div class="control-wrapper">
  <div
    class="status-bar"
    [class.read]="notification().read"
    [class.unread]="!notification().read"></div>
  <div
    class="content"
    (mouseenter)="onHover()"
    (mouseleave)="onLeave()"
    (click)="onClick($event)">
    <div class="properties">
      <div class="property">
        <span class="k-icon k-font-icon k-i-clock icon"></span>
        <span class="text secondary-text">
          {{ notification().time }}
        </span>
      </div>

      <div class="property">
        <span class="k-icon k-font-icon k-i-info-circle icon"></span>
        <span class="text secondary-text">
          {{ notification().title }}
        </span>
      </div>

      <div class="property">
        <span class="k-icon k-font-icon k-i-folder icon-hidden"></span>
        <span class="text secondary-text">
          {{ notification().message }}
        </span>
      </div>
    </div>
    <div class="actions" (click)="actionsClick($event)" kendoTooltip>
      <div class="action">
        <span
          class="k-icon k-font-icon k-i-hyperlink-open-sm icon-button action-control"
          [hidden]="!isHovering"
          title="Display work item"
          (click)="navigate()"></span>
      </div>

      <div class="action">
        <span
          class="k-icon k-font-icon k-i-delete k-i-trash icon-button action-control"
          [hidden]="!isHovering"
          title="Delete notification"
          (click)="onDelete()"></span>
      </div>

      <div class="action">
        <input
          class="notification-selector action-control"
          type="checkbox"
          kendoCheckBox
          [hidden]="!isHovering && !notification().selected"
          [checked]="notification().selected"
          (change)="onSelectionChanged()" />
      </div>
    </div>
  </div>
</div>
